// extracted by mini-css-extract-plugin
export default {"header":"SMTIw","successActions":"_1ublb","desktop":"rzxce","title":"TtNLl","mobile":"hWK1v"};